<script>
    import Page from '../../Page/v1/Page.svelte';
    import PageHeader from '../../../patterns/PageHeader/v1/PageHeader.svelte';

    /** @type {'full'|'wide'|'narrow'} */
    export let contentAreaLayout = 'full';

    /** @type {'h1' | 'h2'} */
    export let headingLevel = 'h1';

    /** @type {string} */
    export let title;

    /** @type {string} */
    export let backLinkText = undefined;

    /** @type {string} */
    export let backLinkUrl = undefined;

    /** @type {string} */
    export let backLinkTarget = '_self';

    /** @type {string} */
    export let backButtonText = undefined;

    /** @type {object[]} */
    export let menuItems = undefined;

    /** @type {boolean} */
    export let responsiveDropdown = true;

    /** @type {object} */
    export let i18n = {
        showMoreOptions: 'Show more options'
    }

    /** @type {string} */
    export let buttonDropdownId = "rnd" + Math.random().toString(36).replace('.', '');
</script>

<Page {contentAreaLayout}>
    <PageHeader {headingLevel}
        {title}
        {backLinkText}
        {backLinkUrl}
        {backLinkTarget}
        {backButtonText}
        {menuItems}
        {responsiveDropdown}
        {i18n}
        {buttonDropdownId}
        on:selectedOption
        on:pageHeaderBack>
        <slot slot="header-menu" name="header-menu" />
        <slot slot="subHeader" name="subHeader" />
    </PageHeader>

    <div class="content-block">
        <slot />
    </div>
</Page>
